import React, {Component} from 'react';

class RedirectUrisCell extends Component {

  handleValueChange = (e) => {
    this.props.onOidcRedirectUrisUpdate(e);
  }

  render() {
    return (
        <input className={this.props.className}
               type='text'
               name={this.props.cellData.type}
               value={this.props.cellData.value}
               id={this.props.cellData.id}
               placeholder={this.props.cellData.placeholder}
               onChange={this.handleValueChange}/>
    );
  }
}

export default RedirectUrisCell;